import React, { useEffect } from 'react';
import winSound from '../assets/sounds/win.mp3';

const GameOverScreen = ({ teams, onRestart }) => {
  const sortedTeams = [...teams].sort((a, b) => b.score - a.score);
  const winner = sortedTeams[0];

  useEffect(() => {
    const winAudio = new Audio(winSound);
    winAudio.play();
  }, []);

  return (
    <div className="p-6 text-center">
      <h2 className="text-2xl font-bold mb-4 text-green-700">🎉 انتهت اللعبة!</h2>
      <p className="text-lg mb-2">الفريق الفائز: <strong>{winner.name}</strong> 🏆</p>

      <h3 className="text-xl mt-4 mb-2">ترتيب الفرق:</h3>
      <ul className="space-y-2">
        {sortedTeams.map((team, index) => (
          <li key={index} className="bg-white p-2 rounded shadow">
            {team.name}: {team.score} نقطة
          </li>
        ))}
      </ul>

      <button
        onClick={onRestart}
        className="mt-6 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
      >
        🔁 ابدأ من جديد
      </button>
    </div>
  );
};

export default GameOverScreen;
